import * as API from '../'
import $const from "../../common/constant";
export default {
  /**
   * 培训资源管理:获取资料列表
   */
  getDataList: params => {
    return API.GET(`/clouddo-tranning/training/resources/data/pageList`, params)
  },
  getPageResourcesList: params => {
    return API.GET(`/clouddo-tranning/training/resources/data/pageResourcesList`, params)
  },
  pageResourcesListRewrite: params => {
    return API.GET(`/clouddo-tranning/training/resources/data/pageResourcesListRewrite`, params)
  },
  delSouceEnt: params => {
    return API.GET(`/clouddo-tranning/souce-ent/delSouceEnt`, params)
  },
  /**
   * 培训资源管理:删除或者禁用单条资料
   */
  delData: params => {
    return API.POST(`/clouddo-tranning/training/resources/data/deleteOrAbleData`, params)
  },
  /**
   * 培训资料单条详情
   */
  getDataDetail: params => {
    return API.GET(`/clouddo-tranning/training/resources/data/getDataDetail`, params)
  },
  /**
   * 培训资料与资源保存(修改,传id)
   */
  postData: params => {
    return API.POST(`/clouddo-tranning/training/resources/data/save`, params)
  },
  /**
   * 根据培训课程id查询培训数据
   * @param params
   * @returns {Promise<*>}
   */
  queryTrainingResourcesDataByTrainingProgramId: params => {
    return API.GET(`/clouddo-tranning/training/resources/data/queryByTrainingProgramId`, params)
  },
  /**
   * 删除上传文件
   */
  deleteFile: params => {
    return API.POST(`/clouddo-tranning/training/resources/data/deleteFile`, params)
  },
  /**
   * 上传文件
   */
  // uploadFile: params => {
  //     return API.POST(`/clouddo-tranning/training/resources/data/upload`, params)
  // },
  // 培训计划管理
  /**
   * 培训计划列表
   */
  getProgramList: params => {
    return API.GET(`/clouddo-tranning/training/program/pageList`, params)
  },
  pageSaftyList: params => {
    return API.GET(`/clouddo-tranning/training/program/page_safty_list`, params)
  },
  getPageProgramList: params => {
    return API.GET(`/clouddo-tranning/training/program/pageProgramList`, params)
  },
  coursePageList:  params => {
    return API.GET(`/clouddo-tranning/training/program/coursePageList`, params)
  },
  openCourseDetails: params => {
    return API.GET(`/clouddo-tranning/training/program/openCourseDetails`, params)
  },
  /**
   * 删除培训计划
   */
  delProgram: params => {
    return API.POST(`/clouddo-tranning/training/program/deleteProgram`, params)
  },
  /**
   * 删除课程
   */
  remove: params => {
    return API.GET(`/clouddo-tranning/training/program/remove`, params)
  },

  /**
   * 新增培训计划
   */
  addProgram: params => {
    return API.POST(`/clouddo-tranning/training/program/save`, params)
  },
  /**
   * 培训计划详情
   */
  getProgramDetail: params => {
    return API.GET(`/clouddo-tranning/training/program/getDataDetail`, params)
  },
  /**
   * 培训计划下发
   */
  planToIssue: params => {
    return API.POST(`/clouddo-tranning/training/program/planToIssue`, params)
  },
  /***
   * 计算总价格
   * @param params
   * @returns {Promise<*>}
   */
  totalCoursePrice: params => {
    return API.POST(`/clouddo-tranning/training/program/totalCoursePrice`, params)
  },
  /**
   * 计算费用
   * @param params
   * @returns {Promise<*>}
   */
  calculateCost: params => {
  return API.POST(`/clouddo-tranning/training/program/calculate-cost`, params)
  },
  /**
   * 培训记录统计列表
   */
  rainingRecordPageList: params => {
    return API.GET(`/clouddo-tranning/training/record/pageList`, params)
  },

  getTrainingProgram: params => {
    return API.GET(`/clouddo-tranning/training/program/getTrainingProgram`, params)
  },
  relevanceExam: params => {
    return API.GET(`/clouddo-tranning/training/program/getExamDetail`, params)
  },
  /**
   * 查询公司列表
   * @param params
   * @returns {Promise<*>}
   */
  findImportEnterprisebaseTree: params => {
    return API.GET(`/clouddo-tranning/training/program/findImportEnterprisebaseList`, params)
  },
  findImportEnterprisebaseTreeRepe: params => {
    return API.GET(`/clouddo-tranning/training/program/findImportEnterprisebaseListRepe`, params)
  },
  /**
   * 查询公司列表
   * @param params
   * @returns {Promise<*>}
   */
  findImportEnterprisebaseTreeRepeated: params => {
    return API.GET(`/clouddo-tranning/training/program/findImportEnterprisebaseRepeatedList`, params)
  },
  /**
   * 导入课程
   * @param params
   * @returns {Promise<*>}
   */
  improtCourse: params => {
    return API.POST(`/clouddo-tranning/training/program/import`, params)
  },
  /**
   * 变更上下架状态
   * @param params
   */
  changeShelf: params => {
    return API.POST(`/clouddo-tranning/training/program/changeShelf`, params)
  },
  getOfflineList: params => {
    return API.GET(`/clouddo-tranning/training/record/offline/pageList`, params)
  },
  delRecod: params => {
    return API.POST(`/clouddo-tranning/training/record/deleteRecod`, params)
  },
  addOffline: params => {
    return API.POST(`/clouddo-tranning/training/record/offline/save`, params)
  },
  summary: params => {
    return API.POST(`/clouddo-tranning/training/record/summary/save1`, params)
  },
  getOfflineDetail: params => {
    return API.GET(`/clouddo-tranning/training/record/getDataDetail`, params)
  },
  recordOfflineExport: params => {
    return API.GETBLOB(`/clouddo-tranning/training/record/offline/export`, params)
  },
  exportSummary: params => {
    return API.GETBLOB(`/clouddo-tranning/training/record/offline/exportSummary`, params)
  },
  getSummary: params => {
    return API.GET(`/clouddo-tranning/training/record/offline/getSummary`, params)
  },
  // 师资管理
  /**
   * 师资分页列表
   */
  getTeacherList: params => {
    return API.GET(`/clouddo-tranning/tranning/teachers/pageList`, params)
  },
  /**
   * 存储师资信息
   */
  saveTeacher: params => {
    return API.POST(`/clouddo-tranning/tranning/teachers/save`, params)
  },
  /**
   * 删除师资信息
   */
  deleteTeacher: params => {
    return API.POST(`/clouddo-tranning/tranning/teachers/delete`, params)
  },
  /**
   * 教师详细信息
   */
  detailsTeacher: params => {
    return API.GET(`/clouddo-tranning/tranning/teachers/details`, params)
  },

  removeList: params => {
    return API.POST(`/clouddo-tranning/training/resources/data/removeList`, params)
  },

  /***
   * 获取清晰度列表
   * @param params
   */
  definitionByResourcesId: params => {
    return API.GET($const.apiServer.Tranning+`/definition/video/listByTrainingResourcesId`, params)
  }


}



// WEBPACK FOOTER //
// ./src/api/new/training.js